import React from 'react'
import { useFormContext } from 'react-hook-form'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import Typography from '@material-ui/core/Typography'
import CurrencyField from 'components/form-util/currency'
import InfoBox from 'components/info-box'
import { flags, useFeatureFlags } from 'lib/feature-flags'

const EventCost = () => {
  const [isStripeFlatFeeDeducted] = useFeatureFlags([
    flags.FLAT_FEAT_STRIPE_FEE_DEDUCTED,
  ])

  const { register, errors, watch } = useFormContext()
  const paymentAccountId = watch('paymentAccountId')
  const feeText =
    'Please note that we use Stripe to process credit card transactions and that it charges a fee of 2.9% + $0.30 applied to the transaction total.'

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Box mb={4}>
        <Typography variant="h4" align="center">
          How much do you want to charge for this event (not per session)?
        </Typography>
      </Box>
      <Container maxWidth="xs">
        <CurrencyField
          name="price"
          label="Price per person"
          fullWidth
          inputRef={register}
          error={!!errors.price}
          helperText={errors?.price?.message}
        />
      </Container>
      {isStripeFlatFeeDeducted && paymentAccountId && (
        <InfoBox text={feeText} maxWidth="sm" />
      )}
    </Box>
  )
}

export default EventCost
